<template>
    <div>
        <div v-if="soup !== undefined">
            <div class="input-container">
                <label for="soup-code" class="label-right">Kód: </label>
                <input type="text" class="input-small" placeholder="Kód" id="soup-code" v-model="soup.soupCode"/>
            </div>

            <div class="input-container">
                <label for="soup-name" class="label-right">Jméno: </label>
                <input type="text" class="input-small" placeholder="Jméno" id="soup-name" v-model="soup.name"/>
            </div>

            <div class="input-container">
                <label for="soup-price" class="label-right">Cena: </label>
                <input type="text" class="input-small" id="soup-price" v-model="soup.price"/>
            </div>

            <div class="input-container">
                <label for="soup-price" class="label-right">Nutnost jídla: </label>
                <check-box class="input-small" id="soup-food-required" v-model="soup.foodRequired"/>
            </div>

            <button class="mdl-button mdl-js-button mdl-button--raised mdl-color--accent save-button" @click="save()">Uložit</button>
        </div>
    </div>
</template>

<script>
    import CheckBox from "./widgets/CheckBox";
    export default {
        name: "SoupItemEditable",
        components: {CheckBox},
        props: {
            soup: null
        },
        methods: {
            save: function () {
                this.$emit('save')
            }
        }
    }
</script>

<style scoped>
    .input-container {
        width: 100%;
        display: inline-block;
        margin-top: 1em;
    }

    .input-small {
        width: 40%;
        float: left;
    }

    .label-right {
        margin-right: 2em;
        width: 40%;
        float: left;
    }

    .save-button {
        color: white;
        width: 100%;
        margin-top: 1em;
        margin-bottom: 1em;
    }
</style>